import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuantityInputBareMHComponent } from './quantity-input-bare.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    QuantityInputBareMHComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    QuantityInputBareMHComponent,
  ]
})
export class QuantityInputBareModule { }
